<template>
    <div class="strain-editor responsive-menu">
      <div class="responsive-menu__child">
        <PageHeader
          :pageHeader="pageHeader"
          :links="[
            { name: 'home', label: 'Home' },
            { name: 'strains', label: 'Strains' },
            {
              name: 'strainEditor',
              label: selectedStrain.name,
              query: $route.query,
            },
          ]"
          :isEdit="isEdit"
          :hideAddButton="true"
          :canEdit="false"
          :isCollapsed="isCollapsed"
          :selectedEntity="selectedStrain"
          @updateIsEdit="isEdit = $event"
          :entity="entity"
          @toggle-edit="toggleEdit"
          @toggle-sections="forceToggle"
          @handle-adjacent="handleAdjacent"
          @show-search-modal="toggleSearchModal"
          @menu-option-click="menuOptionClick"
        />
        <div class="section-base">
          <div class="padded elevated-0 bordered">
            <div class="two-columns-layout two-columns-layout--responsive">
              <div v-for="inputs in strainInputs" :key="inputs.id">
                <div
                  class="
                    grid-two-column
                    two-columns-layout--responsive-horizontal-space-10
                  "
                >
                  <div
                    v-for="input in inputs.inputs"
                    :key="input.id"
                    :class="'input-text' + ' ' + input.class"
                  >
                    <Input
                      :model="selectedStrain[input.id]"
                      @updateModel="selectedStrain[input.id] = $event"
                      :inputData="input"
                      :isEdit="isEdit"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <EditorSection
          :title="`About ${selectedStrain.name || ''}`"
          sectionType="about"
          v-if="selectedStrain._id !== 'NEW'"
          :bus="bus"
        >
          <About :entity="selectedStrain" />
        </EditorSection>
      </div>
      <SearchModal
        v-if="showSearchModal"
        :showSearchModal="showSearchModal"
        @toggle-modal="toggleSearchModal"
        :entity="entity"
        :forcedFilterCriteria="filterCriteria"
        :columnHeaders="columnHeaders"
      />
    </div>
  </template>

  <script>
  import Vue from "vue";
  import PageHeader from "@/components/PageHeader.vue";
  import About from "@/components/About/About.vue";
  import { mapActions, mapGetters } from "vuex";
  import Input from "@/components/Input/Input.vue";
  import moment from "moment";
  import _ from "lodash";
  import Constants from "@/resources/Constants";
  import EditorSection from "@/components/EditorSection";
  import Entities from "@/resources/Entities";

  import {
    strainInputs,
    columnHeaders,
    filterCriteria,
    pageHeader,
  } from "./inputs";

  export default {
    name: "strainEditor",
    data() {
      return {
        Constants: Constants,
        moment: moment,
        strainInputs,
        state: ["biotrack", "metrc"],
        isEdit: false,
        bus: new Vue(),
        isCollapsed: true,
        showSearchModal: false,
        columnHeaders,
        filterCriteria,
        entity: Entities.STRAIN,
        pageHeader,
        strains: [],
      };
    },
    components: {
      PageHeader,
      About,
      Input,
      EditorSection,
    },

    beforeRouteLeave(to, from, next) {
      if (this.isEdit) {
        this.setMessagePopUp({
          isOpen: true,
          title: Constants.strings.unsavedChangesTitle,
          message: Constants.strings.unsavedChangesConfirmation,
          positiveCallback: (data) => {
            next(true);
          },
        });
      } else {
        next(true);
      }
    },
    watch: {
      id: function () {
        if (this.id && this.id !== "NEW") {
          this.getStrainById({
            _id: this.id,
          });
        }
      },
    },
    computed: {
      id: {
        get() {
          return this.$route.query.id;
        },
        set(id) {
          return id;
        },
      },
      ...mapGetters({
        loadingStatus: "strainModule/loadingStatus",
        strain: "strainModule/strain",
        getStrains: "strainModule/strains",
      }),
      selectedStrain: {
        get() {
          this.setPageTitle("Strains" + this.strain.name);
          return this.prefillItemBeforeRendering(this.strain);
        },
        set(entity) {
          return entity;
        },
      },
    },
    methods: {
      ...mapActions({
        getStrainById: "strainModule/getStrainById",
        saveStrain: "strainModule/saveStrain",
        deleteStrain: "strainModule/deleteStrain",
        setMessagePopUp: "setMessagePopUp",
        getAdjacent: "strainModule/getAdjacent",
        retrieveStrains: "strainModule/getStrains",
      }),
      forceToggle() {
        this.isCollapsed = !this.isCollapsed;
        this.bus.$emit("forceToggle", this.isCollapsed);
      },
      handleAdjacent: async function (mode) {
        this.getAdjacent({
          createdAt: this.selectedStrain.createdAt,
          mode,
          positiveCallback: (adjacent) => {
            if (adjacent) this.selectedStrain = adjacent;
          },
        });
      },
      toggleSearchModal: function () {
        this.showSearchModal = !this.showSearchModal;
      },
      prefillItem: function (item) {
      const itemSubsetToCopy = _.pick(item, ["name"]);
      function mergeEmptyItems(objValue, srcValue) {
        if (objValue) return objValue;
        return srcValue;
      }
      _.mergeWith(this.selectedStrain, itemSubsetToCopy, mergeEmptyItems);
      },
      clearItemFromSearch: function (entity) {
        this.selectedStrain[entity] = null;
      },

      // selectItemFromSearch: function (entity, item) {
      //   if (entity === Entities.MSOGROUP && this.selectedStrain._id === "NEW")
      //     this.prefillItem(item);

      //   this.$set(this.selectedStrain, entity, item);
      // },
      toggleEdit() {
        if (!(this.selectedStrain._id === "NEW")) this.isEdit = !this.isEdit;
        if (this.selectedStrain._id === "NEW") {
          this.isEdit = true;
        }
      },
      menuOptionClick(entity, key) {
        if (key === "strain-listing") {
          window.open(`/reports/inventory/inventoryListStrain`);
        }
      },
      closeHandler() {
        this.setStrainOrderingPopUpOpen(false);
      },
      saveHandler(updatedStrains) {
        this.updateStrainOrdering(updatedStrains).then(() => {
          this.closeHandler();
        });
      },
      prefillItemBeforeRendering(entity) {
      return entity;
    },
    },
    async mounted() {
      this.setPageTitle("Strain");
      if (this.$route.query.id) {
        this.getStrainById({
          _id: this.$route.query.id,
          positiveCallback: (strain) => {
            this.setPageTitle(`Strain ${strain.name}`);
          },
        });
      } else {
        this.isEdit = true;
        this.$store.commit("strainModule/setStrain", { _id: "NEW" });
      }
      let strainsInStore = this.getStrains;
      if (!strainsInStore || strainsInStore.length == 0) {
        await this.retrieveStrains().then((data) => {
          strainsInStore = data;
        });
      }
    },
  };
  </script>